import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Collapse } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';

export default function FilterToggle({
  title,
  children,
  first,
}) {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <div className={classNames('FilterToggle', { 'FilterToggle--first': first })}>
      <button className="FilterToggle__label" onClick={toggle}>
        <div className="FilterToggle__label__text">
          {title}
        </div>
        <div className="FilterToggle__label__icon">
          {isOpen ?
            <FontAwesomeIcon icon={faMinus} />
            :
            <FontAwesomeIcon icon={faPlus} />
          }
        </div>
      </button>

      <div className="FilterToggle__content">
        <Collapse isOpen={isOpen}>
          {children}
        </Collapse>
      </div>
    </div>
  );
}

FilterToggle.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  first: PropTypes.bool,
};

FilterToggle.defaultProps = {
  long: false,
  first: false,
};
